module.exports = __webpack_public_path__ + "static/media/ivete_04.aac54171.mp4";